import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "AIzaSyDgmZU6RL4tXLppImI9qYpvhsBZC3Z02fE",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "puls.gr",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "puls-44484",
  databaseURL:
    import.meta.env.VITE_FIREBASE_DATABASE_URL ??
    "https://puls-44484-default-rtdb.europe-west1.firebasedatabase.app",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "puls-44484.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "635459502389",
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? "1:635459502389:web:a0016f252d6854ae188c7c",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? "G-7E9V2YXS0L"
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const functions = getFunctions(firebaseApp, "us-central1");
export const realtimeDb = getDatabase(firebaseApp);
export const storage = getStorage(firebaseApp);
